import React from 'react'

import { motion } from 'framer-motion'

const Fade = ({ children }) => {
  return (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          mass: 0.35,
          stiffness: 100,
          duration: 0.25
        }}
    >
    {children}
    </motion.div>
  )
}

export default Fade
